import { z } from "zod";
import {
  ParameterSourceSchema,
  ParameterVisualRoleSchema,
  RestrictionTypeSchema,
  StatusMappingSchema,
} from "./parameters.js";
import { ProductionRoleSchema, UnitFactorSchema } from "./parameters-counter.js";
import { LossTypeSchema } from "./common.js";
import { TmpIdSchema } from "./draft-line-tmp.js";

const draftBase = {
  tmpId: TmpIdSchema,
  name: z.string().min(1).max(120),
  description: z.string().max(500).optional(),
};

/**
 * Spec 080 — o papel visual viaja em TODA categoria, e quem julga se ele cabe naquela categoria é
 * `assertVisualRoleCompatible` no service (a autoridade única). Declarar aqui a lista permitida por
 * categoria duplicaria a regra em dois lugares que precisariam mudar juntos — e foi a ausência
 * DESTE campo que fazia o rascunho descartar em silêncio o que a barra lateral deixava preencher.
 */
const draftVisualRole = {
  visualRole: ParameterVisualRoleSchema.optional().default("NONE"),
};

/** Spec 080 — limites de alarme só existem em numérico; o service reafirma (`resolveLimitsUpdate`). */
const draftLimits = {
  limitMax: z.number().finite().nullable().optional(),
  limitMin: z.number().finite().nullable().optional(),
};

export const DraftParameterSchema = z.discriminatedUnion("category", [
  z.object({
    ...draftBase,
    ...draftVisualRole,
    category: z.literal("STATUS"),
    source: ParameterSourceSchema,
    statusMapping: StatusMappingSchema,
    generatesAlarm: z.boolean().optional(),
  }),
  z.object({
    ...draftBase,
    ...draftVisualRole,
    ...draftLimits,
    category: z.literal("NUMERIC"),
    unit: z.string().min(1).max(20),
    source: ParameterSourceSchema,
    isRestriction: z.boolean().optional(),
    restrictionType: RestrictionTypeSchema.optional(),
  }),
  z.object({
    ...draftBase,
    ...draftVisualRole,
    category: z.literal("COUNTER"),
    unit: z.string().min(1).max(20),
    source: ParameterSourceSchema,
    // Spec 081 — o rascunho carrega o sentido do contador (e o que o acompanha), senão a criação
    // atômica da linha descartaria a configuração que o gestor acabou de declarar.
    productionRole: ProductionRoleSchema.optional(),
    productId: z.string().uuid().optional(),
    lossType: LossTypeSchema.optional(),
    unitFactor: UnitFactorSchema.optional(),
  }),
  z.object({
    ...draftBase,
    ...draftVisualRole,
    category: z.literal("BOOLEAN"),
    source: ParameterSourceSchema,
    // Spec 080 — o booleano do relé térmico é restrição operacional como qualquer numérico com
    // faixa: marcado, `1`/`true` para a máquina. Sem este campo o rascunho descartaria a marca.
    isRestriction: z.boolean().optional(),
  }),
  z.object({
    ...draftBase,
    category: z.literal("TEXT"),
    source: ParameterSourceSchema,
  }),
  z.object({
    ...draftBase,
    category: z.literal("DURATION"),
    unit: z.enum(["s", "min", "h"]),
    source: ParameterSourceSchema,
  }),
]);
export type DraftParameter = z.infer<typeof DraftParameterSchema>;
